import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { QueryClient, QueryClientProvider, useInfiniteQuery } from '@tanstack/react-query';
import { useEventCallback, useForkRef } from '@mui/material/utils';
import useTimeout from '@mui/utils/useTimeout';
import { useVirtualizer } from '@tanstack/react-virtual';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Autocomplete": Autocomplete, "@mui/material/CircularProgress": CircularProgress, "@mui/material/TextField": TextField, "@tanstack/react-query": { QueryClient, QueryClientProvider, useInfiniteQuery }, "@mui/material/utils": { useEventCallback, useForkRef }, "@mui/utils/useTimeout": useTimeout, "@tanstack/react-virtual": { useVirtualizer } } } });
export default ClientProvider;
